import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { accountService } from 'services';
import { displayNotification } from 'utils';
import { useI18n } from 'contexts/i18n';

export const useUpdateEmailSubscribe = () => {
  const queryClient = useQueryClient();
  const i18n = useI18n();
  return useMutation(
    (subscribeOption: { user: { opt_in: boolean } }) => {
      return accountService.updateEmailSubscription(subscribeOption);
    },
    {
      onSuccess: async (data, variables, context) => {
        displayNotification(i18n['Email subscription updated']);
        await queryClient.invalidateQueries([
          ServerStateKeysEnum.accountDetails,
        ]);
      },
      onError: error => {
        displayNotification(
          i18n['Failed to update email subscription!'],
          'danger'
        );
        console.log('useUpdateEmailSubscribe error', error);
      },
    }
  );
};
